import React from "react";

export const Arrow = ({ className = "arrow" }) => (
  <svg className={className} viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <path d="M1 8h13M9 3l5 5-5 5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="square" />
  </svg>
);

export const ArrowDown = ({ className = "" }) => (
  <svg className={className} viewBox="0 0 16 24" fill="none" aria-hidden="true">
    <path d="M8 1v21M2 17l6 6 6-6" stroke="currentColor" strokeWidth="1" />
  </svg>
);

export const Star = ({ className = "" }) => (
  <svg className={className} viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
    <path d="M10 1.5l2.6 5.6 6.1.7-4.5 4.2 1.2 6.1L10 15l-5.4 3.1 1.2-6.1L1.3 7.8l6.1-.7z" />
  </svg>
);

export const Sparkle = ({ className = "" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 0c.6 6.8 4.6 11.2 12 12-7.4.8-11.4 5.2-12 12-.6-6.8-4.6-11.2-12-12C7.4 11.2 11.4 6.8 12 0z" />
  </svg>
);
